/** Ensures `values` always exists (required by the module type), falling back to `[]`. */
export const toResolvedConfigModuleParameterSet = <T extends { values?: unknown[] }>(
  parameterSet: T,
  values: NonNullable<T['values']> = (parameterSet.values ?? []) as NonNullable<T['values']>,
) => ({
  ...parameterSet,
  values,
});
